import { render, staticRenderFns } from "./MaterialCategoryList.vue?vue&type=template&id=28c22f3e&scoped=true"
import script from "./MaterialCategoryList.vue?vue&type=script&lang=js"
export * from "./MaterialCategoryList.vue?vue&type=script&lang=js"
import style0 from "./MaterialCategoryList.vue?vue&type=style&index=0&id=28c22f3e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c22f3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28c22f3e')) {
      api.createRecord('28c22f3e', component.options)
    } else {
      api.reload('28c22f3e', component.options)
    }
    module.hot.accept("./MaterialCategoryList.vue?vue&type=template&id=28c22f3e&scoped=true", function () {
      api.rerender('28c22f3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/material/MaterialCategoryList.vue"
export default component.exports